import React, { FC, ReactNode } from 'react';
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';

import SimpleMap from '../map/simple-map';

interface MapDialogProps extends WithStyles<typeof styles> {
  title: string | ReactNode;
  open: boolean;
  coords: [number, number];
  setOpen(val: false): void;
}

const MapDialog: FC<MapDialogProps> = (props) => {
  const { classes, title, open, setOpen, coords } = props;
  if (!open) {
    return null;
  }
  return (
    <MuiDialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
      <MuiDialogTitle disableTypography className={classes.root}>
        <Typography variant="h6">{title}</Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => setOpen(false)}
        >
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
      <MuiDialogContent dividers classes={{ root: classes.content }}>
        <SimpleMap
          coords={coords}
          points={[
            {
              type: 'outlet',
              geometry: { type: 'outlet', coordinates: coords },
              properties: {},
            },
          ]}
        />
      </MuiDialogContent>
    </MuiDialog>
  );
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingRight: '40px',
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    content: {
      minHeight: 600,
      minWidth: 600,
      padding: '0',
      '& .leaflet-container': {
        height: '598px',
      },
    },
  });

export default withStyles(styles)(MapDialog);
